import { apiClient } from '@/lib/api/client'

/**
 * SOLY-PLAN-005 — planning crews API client.
 *
 * A crew is a named, stable group of people the agenda shows as ONE lane instead of one lane per
 * member. Endpoints exposed by PlanningCrewsController (all behind `users:manage`):
 *   GET    /api/admin/planning/crews                        — crews + their members
 *   POST   /api/admin/planning/crews                        — create
 *   DELETE /api/admin/planning/crews/{crewId}               — delete (members become crewless)
 *   PUT    /api/admin/planning/crews/{crewId}/members/{id}  — assign (MOVES if already in another)
 *   DELETE /api/admin/planning/crews/{crewId}/members/{id}  — unassign
 *
 * Reading which crew a PERSON is in does not go through here: `crewId`/`crewName` travel on the
 * employee roster (`getEmployees`), which the agenda already loads.
 */

export type CrewDto = {
  id: string
  name: string
  memberUserIds: string[]
}

export async function getCrews(): Promise<CrewDto[]> {
  return apiClient.get<CrewDto[]>('/api/admin/planning/crews')
}

export async function createCrew(name: string): Promise<CrewDto> {
  return apiClient.post<CrewDto>('/api/admin/planning/crews', { name })
}

export async function deleteCrew(crewId: string): Promise<void> {
  await apiClient.delete<void>(`/api/admin/planning/crews/${crewId}`)
}

/** Puts a person in this crew. Someone already in another crew is MOVED, not refused. */
export async function assignCrewMember(crewId: string, userId: string): Promise<void> {
  await apiClient.put<void>(`/api/admin/planning/crews/${crewId}/members/${userId}`, {})
}

export async function unassignCrewMember(crewId: string, userId: string): Promise<void> {
  await apiClient.delete<void>(`/api/admin/planning/crews/${crewId}/members/${userId}`)
}
